/**
 * Centralized timing constants for debouncing and delays
 * All values in milliseconds
 *
 * Note: Lobby updates happen via Supabase Realtime presence sync, which has a built-in
 * heartbeat of ~15 seconds. We no longer use explicit polling for lobby/game updates.
 */

export const TIMING = {
  // Lobby refresh debounce
  LOBBY_REFRESH_DEBOUNCE: 0.5 * 1000, // 500ms - debounce rapid presence sync events

  // Note: Supabase presence heartbeat (~15s) automatically triggers lobby refreshes
  // No explicit polling needed - see LobbyManager presence sync handler

  // Tournament lobby polling interval
  TOURNAMENT_POLL_INTERVAL: 15 * 1000, // 30 seconds

  // Idle detection - show warning 30 seconds before pausing
  IDLE_WARNING_MS: 4.5 * 60 * 1000, // 4.5 minutes
  IDLE_WARNING_DURATION_MS: 30 * 1000, // 30 seconds to respond

  // Ball launch Y-position restriction (world coordinates)
  // Set to large value (e.g., 99999) to allow launching from anywhere for testing
  LAUNCH_Y_BUFFER: 40, // ±10px from starting launch position

  // Add other timing constants here as needed
} as const;

// Helper functions to convert seconds/minutes to milliseconds for readability
export const seconds = (n: number) => n * 1000;
export const minutes = (n: number) => n * 60 * 1000;

// Usage examples:
// setInterval(() => { ... }, TIMING.LOBBY_POLL_INTERVAL);
// setTimeout(() => { ... }, TIMING.LOBBY_REFRESH_DEBOUNCE);
